
  const ErrorMapping = {
    "auth/email-already-in-use" : "email already in use",
    "auth/wrong-password": "Incorrect credentials",
    "auth/weak-password": "password must be 6 or more characters long",
    "auth/user-not-found": "please enter a valid email address or password",
    "auth/unknown" : "please try again later",
  }
  export default ErrorMapping;